import React, { useState, useEffect, useRef } from "react";
import down from "../../../Assets/Icons/icon_down_arrow.png";
import "./styles.css";

// Dropdown component for reusable dropdowns
const Dropdown = ({
  options,
  onSelect,
  selectedOption,
  boxStyle,
  listStyle,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    // Function to close the dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Add event listener on mount
    document.addEventListener("click", handleClickOutside);

    // Remove event listener on unmount
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    onSelect(option); // Trigger the provided onSelect function
    setIsOpen(false); // Close the dropdown after selecting an option
  };

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <div
        className="dropdown-title-box"
        onClick={() => setIsOpen(!isOpen)}
        style={boxStyle}
      >
        <p className="medium-grey body1">{selectedOption}</p>
        <img alt="Dropdown Arrow Icon" src={down} />
      </div>
      {isOpen && (
        // Dropdown options displayed when isOpen is true
        <ul className="dropdown" style={listStyle}>
          {options?.map((item, index) => (
            <li key={index}>
              <div
                className="body2 dark-grey li-text"
                onClick={() => {
                  handleSelect(item);
                }}
              >
                {item?.name || item?.reportType?.name || item}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
